export default {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700,
  black: 900,
};
